var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-profile-data",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-profile-data:not(.animated) .animable {opacity: 0;}svg#freepik_stories-profile-data.animated #freepik--background-simple--inject-33 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-profile-data.animated #freepik--Document--inject-33 {animation: 1s 1 forwards ease-in lightSpeedLeft;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-33",
    className: "animable",
    style: {
      transformOrigin: "245.916px 250.609px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "el8l9uxb66rgg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.93,167.09s-27.88,72,11.3,144.5S199.11,422.39,263.7,455.14s131.66,16.8,163.53-36.84-11.84-91.93-11.9-168.42,11.45-96.74-30-161.36-143.06-78.93-219.9-31S67.93,167.09,67.93,167.09Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "248.588px 250.609px"
    },
    className: "animable",
    id: "el5u5v1yb1wns"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.82,453.22s-89.4-122.39-34-216.46,165.43-29.51,186.38-117.3,97.42-102.18,169.94,7.6,55.17,262.45,16.77,326.16Z",
    style: {
      fill: "#3B9BE8",
      transformOrigin: "245.916px 251.185px"
    },
    id: "elyp1op09o8ft",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3umjsp8i7co"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.82,453.22s-89.4-122.39-34-216.46,165.43-29.51,186.38-117.3,97.42-102.18,169.94,7.6,55.17,262.45,16.77,326.16Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "245.916px 251.185px"
    },
    className: "animable",
    id: "elhgg6hlr054"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-33",
    className: "animable",
    style: {
      transformOrigin: "250px 453.22px"
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 39.32,
    y1: 453.22,
    x2: 460.68,
    y2: 453.22,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "250px 453.22px"
    },
    id: "el2zd8qjaxkmo",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-33",
    className: "animable",
    style: {
      transformOrigin: "279.366px 338.445px"
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 124.06,
    y1: 339.11,
    x2: 124.06,
    y2: 452.64,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "124.06px 395.875px"
    },
    id: "elif6xbfjjils",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.06,
    y1: 324.87,
    x2: 124.06,
    y2: 334.2,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "124.06px 329.535px"
    },
    id: "eleiwexdfpqm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "385.26 452.89 385.26 301.8 124.06 301.8 124.06 319.6",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "254.66px 377.345px"
    },
    id: "ellhk4tws4z4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "358.57 310.66 374.47 310.66 374.47 445.46",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "366.52px 378.06px"
    },
    id: "el8h9lyxjmc5l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "134.86 452.64 134.86 310.66 349.34 310.66",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "242.1px 381.65px"
    },
    id: "elxc4tbrufqoe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142.47,
    y1: 293.4,
    x2: 147.52,
    y2: 293.4,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "144.995px 293.4px"
    },
    id: "eln8t4of83tx8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "154.77 293.4 389.82 293.4 389.82 301.74 119.51 301.74 119.51 293.4 139.25 293.4",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "254.665px 297.57px"
    },
    id: "el1qlfclzcz7a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.95,
    y1: 289.28,
    x2: 428.47,
    y2: 305.37,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "429.71px 297.325px"
    },
    id: "elystejuxffsg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.74,223.23h12a11.49,11.49,0,0,1,11.35,13.23l-6.78,44",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "427.481px 251.845px"
    },
    id: "el3ue79qle59s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 403.54,
    y1: 223.23,
    x2: 412.31,
    y2: 223.23,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "407.925px 223.23px"
    },
    id: "elzdhz4mnbcfe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.16,289.2,360.83,233a11.47,11.47,0,0,1,11.34-9.73h25.12",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "374.725px 256.235px"
    },
    id: "el3mwjxvl3t69",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 344.33,
    y1: 340.01,
    x2: 348.23,
    y2: 314.67,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "346.28px 327.34px"
    },
    id: "elz3hv3yjzo6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.72,372.35h11.94a22,22,0,0,0,15.26-6.15",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "402.32px 369.275px"
    },
    id: "elfqx775cqr79",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 322.91,
    y1: 372.35,
    x2: 364.52,
    y2: 372.35,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "343.715px 372.35px"
    },
    id: "elecako69dxqt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.71,368.59a21.93,21.93,0,0,0,12.3,3.76",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "311.86px 370.47px"
    },
    id: "el1p7u36h4zh3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,340H304.22a8.2,8.2,0,0,0-8.2,8.2v2.14A21.9,21.9,0,0,0,300.76,364",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "333.51px 352px"
    },
    id: "el9v08k6nwjdg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.06,345.12a8.22,8.22,0,0,0-7.6-5.11h-11.9",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "412.31px 342.565px"
    },
    id: "elgdbsa9r0mf9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "371.12 378.39 342.55 378.39 336.55 372.35",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "353.835px 375.37px"
    },
    id: "elvxd581fo4y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.76,378.39h17.15a0,0,0,0,1,0,0v20.1a1.82,1.82,0,0,1-1.82,1.82H352.58a1.82,1.82,0,0,1-1.82-1.82v-20.1A0,0,0,0,1,350.76,378.39Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "359.335px 389.35px"
    },
    id: "el1raq1nq1r0g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.97,
    y: 400.31,
    width: 10.73,
    height: 24.69,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "359.335px 412.655px"
    },
    id: "elkce6nrz5uh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.19,440.2C328.05,428.3,354,425,354,425",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "332.095px 432.6px"
    },
    id: "el26cp8ubs17m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.08,436.65C353,434,335,438,318,442.38",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "344.54px 439.09px"
    },
    id: "elgo6iomirnw8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.64,442.38c-4.12-1.06-8.28-2-12.45-2.84",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "394.415px 440.96px"
    },
    id: "elz8adzuyscw9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.72,430.81a85.36,85.36,0,0,1,19.77,9.39",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "398.605px 435.505px"
    },
    id: "elhxfj8hjug7k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.7,425c2.26.31,4.5.71,6.74,1.17",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "368.07px 425.585px"
    },
    id: "el4maf7610qkn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.29,
    cy: 446.93,
    r: 6.73,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "312.29px 446.93px"
    },
    id: "elolp9fzasnu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.29,
    cy: 446.93,
    r: 6.73,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "407.29px 446.93px"
    },
    id: "el7bojkrau7xy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.13,358.63l5.28-35.74a7.77,7.77,0,0,1,6.64-6.57L435.58,313a3.8,3.8,0,0,0,3.28-3.77h0a3.81,3.81,0,0,0-3.8-3.81H432l-24.3,3.75a13.55,13.55,0,0,0-11.37,11.62l-5.08,38.76a2.4,2.4,0,0,0,2.37,2.71h0",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "415.045px 333.84px"
    },
    id: "eldlwdam7q0zo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.58,313l-6.38,33.94h0a3.19,3.19,0,0,1,3.19,3.19v6.48a8.1,8.1,0,0,1-8.1,8.1H394.47",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "415.025px 338.855px"
    },
    id: "elvl9npuzga1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "431.35 313.53 424.71 346.17 407.29 346.17",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "419.32px 329.85px"
    },
    id: "elssnar8fraf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 304.3,
    y1: 320.74,
    x2: 302.52,
    y2: 334.36,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "303.41px 327.55px"
    },
    id: "eldiluqw9ggj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.52,335.72l1.89-12.83a7.77,7.77,0,0,1,6.64-6.57L343.58,313",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "327.05px 324.36px"
    },
    id: "elitoq0xprd4j",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Document--inject-33",
    className: "animable",
    style: {
      transformOrigin: "167.16px 275.33px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.62,
    y: 97.44,
    width: 201.08,
    height: 355.78,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "167.16px 275.33px"
    },
    id: "el67bqllbil9i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.22,
    y1: 312.37,
    x2: 78.01,
    y2: 312.37,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "167.115px 312.37px"
    },
    id: "elnr6w9ba1ru",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.01,
    y1: 238.74,
    x2: 256.22,
    y2: 238.74,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "167.115px 238.74px"
    },
    id: "eln219bdqyvu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.01,
    y: 141.94,
    width: 58.02,
    height: 85.56,
    style: {
      fill: "#3B9BE8",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "107.02px 184.72px"
    },
    id: "elqljrthsy5jj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.22,227.51V199.84a67.34,67.34,0,0,0-24.89-4.45c-10.47.11-19.74,2-24.76,4.21v27.91Z",
    style: {
      fill: "#3B9BE8",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "106.395px 211.448px"
    },
    id: "el4gtma2wj8ah",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.32,227.51H110l-1.62-20.58,2.39-5.14s-3.87-1.38-6.86,0l1.53,5.14Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "107.045px 214.343px"
    },
    id: "elhm83n0qpdyj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.29 192.11 118.74 195.38 113.22 208.71 107.02 201.79 100.17 208.71 94.03 195.38 98.48 192.11 114.29 192.11",
    style: {
      fill: "#3B9BE8",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "106.385px 200.41px"
    },
    id: "eld2ekni358t6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.59,193.73s-4.79,7-8.57,7.12c-2.67.07-9.54-6.57-9.54-6.57,1.86-1.67,2-4.75,1.7-7.18a21.18,21.18,0,0,0-.7-3.53h15.81a13.43,13.43,0,0,0-.56,7A5.2,5.2,0,0,0,115.59,193.73Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "106.535px 192.21px"
    },
    id: "elb1w0w5t86pt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.73,190.58c-11.42,3-13.68-3.53-13.68-3.53l-.87,0a21.18,21.18,0,0,0-.7-3.53h15.81A13.43,13.43,0,0,0,113.73,190.58Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "106.385px 187.444px"
    },
    id: "eleou3b5g6jr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.69,172.27s7.58-24.24-20.21-17.66c0,0-2.27-1.18-3.66-.64s-2.73,10.33-.37,19.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "106.397px 163.414px"
    },
    id: "eltjomlwsekh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.73,172.48s1.27-1.39,1.9-.93a3,3,0,0,1,1,2.92c-.34,1.17-1.82,3.22-1.93,4.41s-.88,2.55-1.72,1.76S117.73,172.48,117.73,172.48Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "118.716px 176.166px"
    },
    id: "elk1stx1zr0qn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,172.48s-1.27-1.39-1.89-.93a3,3,0,0,0-1,2.92c.34,1.17,1.82,3.22,1.94,4.41s.88,2.55,1.71,1.76S95,172.48,95,172.48Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "94.0219px 176.166px"
    },
    id: "el1fbtp209l8t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.12,156.49c16,0,12.2,21.32,9.25,28.17-1,2.4-6.39,5.55-9,5.55-2.41,0-7.93-3.77-8.91-6C94.5,177.31,90.86,156.49,106.12,156.49Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "106.414px 173.35px"
    },
    id: "elq0qp3ykrc4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.83,169.65s4.17-1.28,5.46,1.29",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "111.56px 170.136px"
    },
    id: "ell0rlf0ivqt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.92,173.16c0,.49-.25.89-.56.89s-.56-.4-.56-.89.25-.89.56-.89S111.92,172.67,111.92,173.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "111.36px 173.16px"
    },
    id: "eldc16d7m5olc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.94,169.65s-4.17-1.28-5.46,1.29",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "101.21px 170.136px"
    },
    id: "elae7d34zeebn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.86,173.16c0,.49.24.89.55.89s.56-.4.56-.89-.25-.89-.56-.89S100.86,172.67,100.86,173.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "101.415px 173.16px"
    },
    id: "elc0ghixc34z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.39,162.9c-.85,1.09,0,4.44.23,5.81S95.75,171,96,174.47l-.81,1.19s-2.26-5.55-1.69-10.33,3.58-6.63,3.58-6.63,1.37-4.12,9.43-4.09c8.68,0,9.56,4.73,9.56,4.73s5.88,3.93,1.53,16.72l-.95-1.59a7.14,7.14,0,0,0-1.1-4.85c-.75-1.11.46-4.44.18-6.14S98.25,161.82,97.39,162.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "106.306px 165.335px"
    },
    id: "eloozbgitqrgl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.34,172.27s.24,4.92.94,6.31-1.76,1.61-2.81.79",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "106.937px 176.059px"
    },
    id: "ela2ng1n2ng8v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.88,182a3.16,3.16,0,0,0,1.49,1.91,9.78,9.78,0,0,0,5-.12,3.36,3.36,0,0,0,.94-1.67",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "106.595px 183.089px"
    },
    id: "elxa3foz194yi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.53,181.92a19.61,19.61,0,0,0,8.27,0",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "106.665px 182.14px"
    },
    id: "elzqbb3wgn3iq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.19 197.04 78.01 200.41 78.01 227.5 105.68 227.5 90.19 197.04",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "91.845px 212.27px"
    },
    id: "elcuuf7m1m7ww",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.03 201.18 120.73 196.34 107.95 227.5 136.03 227.5 136.03 201.18",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "121.99px 211.92px"
    },
    id: "eli7or2dk38kp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.31 227.51 122.32 217.02 116.75 211.68 125.29 206.93 122.35 197.11 118.74 195.38 107.78 227.51 113.31 227.51",
    style: {
      fill: "rgb(191, 191, 191)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "116.535px 211.445px"
    },
    id: "elwhqxi30u2je",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.07 218.1 100.04 227.51 106.02 227.51 94.03 195.38 90.19 197.04 87.31 206.16 96.02 213.07 91.07 218.1",
    style: {
      fill: "rgb(191, 191, 191)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "96.665px 211.445px"
    },
    id: "elv0j4es82xp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.28,110.62v1.79c0,2.21-1.07,3.41-3.23,3.41h-1V121h-2.16V107.21h3.19C133.21,107.21,134.28,108.41,134.28,110.62ZM130,109.18v4.67h1c.69,0,1.06-.32,1.06-1.3v-2.07c0-1-.37-1.3-1.06-1.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "131.085px 114.105px"
    },
    id: "elqd3z8qd9vtj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.81,121a4.15,4.15,0,0,1-.2-1.69v-2.17c0-1.28-.43-1.75-1.41-1.75h-.75V121h-2.17V107.21h3.27c2.24,0,3.21,1.05,3.21,3.17v1.09a2.71,2.71,0,0,1-1.42,2.77v0c1.08.45,1.44,1.48,1.44,2.91v2.13A4.15,4.15,0,0,0,142,121Zm-2.36-11.81v4.23h.84c.81,0,1.3-.35,1.3-1.45V110.6c0-1-.33-1.42-1.1-1.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "138.64px 114.105px"
    },
    id: "el50lpn9d2fac",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,110.52c0-2.2,1.16-3.46,3.29-3.46s3.28,1.26,3.28,3.46v7.17c0,2.2-1.16,3.46-3.28,3.46s-3.29-1.26-3.29-3.46Zm2.17,7.3c0,1,.43,1.36,1.12,1.36s1.12-.37,1.12-1.36v-7.44c0-1-.43-1.36-1.12-1.36s-1.12.38-1.12,1.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "146.285px 114.105px"
    },
    id: "elvfiaevgdpbr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.16,113.34H156v2h-2.79V121H151V107.21h5.73v2h-3.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "153.865px 114.105px"
    },
    id: "elxfnhfd54n9l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.77,107.21h2.16V121h-2.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "158.85px 114.105px"
    },
    id: "elejdbhooneg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.51,107.21h2.16V119h3.57v2h-5.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "164.375px 114.105px"
    },
    id: "elcj0l113b8e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.35,113h3v2h-3v4h3.74v2h-5.91V107.21h5.91v2h-3.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "171.135px 114.105px"
    },
    id: "elki6wruaesj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.48,107.21h3.43c2.16,0,3.22,1.2,3.22,3.41v7c0,2.2-1.06,3.4-3.22,3.4h-3.43Zm2.17,2V119h1.22c.69,0,1.1-.35,1.1-1.33v-7.17c0-1-.41-1.34-1.1-1.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "181.805px 114.115px"
    },
    id: "elvjfbik1174",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.5,121h-2.18l-.38-2.5h-2.65l-.38,2.5h-2l2.21-13.78h3.17Zm-4.94-4.37h2.09l-1-7h0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "189.705px 114.11px"
    },
    id: "elefs0e4oxsjg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.13,107.21h6.69v2h-2.26V121h-2.17V109.18h-2.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "196.475px 114.105px"
    },
    id: "elf9vnr9tpszo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,121h-2.19l-.37-2.5h-2.66l-.37,2.5h-2l2.2-13.78h3.17Zm-4.94-4.37h2.08l-1-7h0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "203.205px 114.11px"
    },
    id: "el2wdnsqqdicv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.06,
    y1: 131.7,
    x2: 256.26,
    y2: 131.7,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "167.16px 131.7px"
    },
    id: "el3oq3oner7v4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.75,146.33h43.56a1.8,1.8,0,1,0,0-3.59H147.75a1.8,1.8,0,0,0,0,3.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "169.664px 144.535px"
    },
    id: "ela9dzsu2izjm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.78,155.08h-60a1.8,1.8,0,0,0,0,3.59h60a1.8,1.8,0,0,0,0-3.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "177.78px 156.875px"
    },
    id: "elypfq2cql9v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.85,167.43h-27.1a1.8,1.8,0,0,0,0,3.59h27.1a1.8,1.8,0,1,0,0-3.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "161.434px 169.225px"
    },
    id: "elotewjfi55l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.78,179.78h-60a1.8,1.8,0,0,0,0,3.59h60a1.8,1.8,0,0,0,0-3.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "177.78px 181.575px"
    },
    id: "elc3ty2wp14f9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.08,192.12H147.75a1.8,1.8,0,0,0,0,3.59h35.33a1.8,1.8,0,1,0,0-3.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "165.549px 193.915px"
    },
    id: "eletl32hl1ru6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.96,
    y: 206.27,
    width: 19.46,
    height: 19.46,
    style: {
      fill: "rgb(191, 191, 191)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "155.69px 216px"
    },
    id: "el7cj02r9obm7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.96,
    y: 206.27,
    width: 19.46,
    height: 19.46,
    style: {
      fill: "rgb(191, 191, 191)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "185.69px 216px"
    },
    id: "elxz58uaxlh6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.96,
    y: 206.27,
    width: 19.46,
    height: 19.46,
    style: {
      fill: "rgb(191, 191, 191)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "215.69px 216px"
    },
    id: "ele1e2h22aqob",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.92,
    cy: 269.3,
    r: 17.36,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      strokeWidth: 5,
      transformOrigin: "107.92px 269.3px"
    },
    id: "elm5xj666dkb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.29,269.3a17.37,17.37,0,1,1-17.37-17.37",
    style: {
      fill: "none",
      stroke: "#3B9BE8",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5,
      transformOrigin: "107.92px 269.3px"
    },
    id: "elo2bmsng14e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.47,296.47H94.38a1.8,1.8,0,1,0,0,3.59h27.09a1.8,1.8,0,1,0,0-3.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "107.925px 298.265px"
    },
    id: "elbwlvdu8wsss",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.18,
    cy: 269.3,
    r: 17.36,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      strokeWidth: 5,
      transformOrigin: "165.18px 269.3px"
    },
    id: "elotmsb6b48q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.46,281.57a17.36,17.36,0,1,1-12.28-29.64",
    style: {
      fill: "none",
      stroke: "#3B9BE8",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5,
      transformOrigin: "162.645px 269.29px"
    },
    id: "elile6qwnoxi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.73,296.47h-27.1a1.8,1.8,0,0,0,0,3.59h27.1a1.8,1.8,0,1,0,0-3.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "165.314px 298.265px"
    },
    id: "eldopm9zxgcqu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.44,
    cy: 269.3,
    r: 17.36,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      strokeWidth: 5,
      transformOrigin: "222.44px 269.3px"
    },
    id: "el05p3b0c0l31s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.44,286.66a17.37,17.37,0,0,1,0-34.73",
    style: {
      fill: "none",
      stroke: "#3B9BE8",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5,
      transformOrigin: "213.963px 269.295px"
    },
    id: "el125hulogo8d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,296.47h-27.1a1.8,1.8,0,0,0,0,3.59H236a1.8,1.8,0,0,0,0-3.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "222.45px 298.265px"
    },
    id: "elx26vbkkqhn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.06,
    y: 323.37,
    width: 33.5,
    height: 33.5,
    style: {
      fill: "rgb(191, 191, 191)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "94.81px 340.12px"
    },
    id: "elmw16dfnhpcs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.75,327H225.31a1.8,1.8,0,1,0,0-3.59H121.75a1.8,1.8,0,0,0,0,3.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "173.664px 325.205px"
    },
    id: "el89z1n9g717",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.78,335.72h-120a1.8,1.8,0,0,0,0,3.59h120a1.8,1.8,0,0,0,0-3.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "181.78px 337.515px"
    },
    id: "elrm1daa9gcq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.85,348.06H121.75a1.8,1.8,0,0,0,0,3.59h117.1a1.8,1.8,0,1,0,0-3.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "180.434px 349.855px"
    },
    id: "elzpesbnyu9sf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.78,360.41h-120a1.8,1.8,0,0,0,0,3.59h120a1.8,1.8,0,0,0,0-3.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "181.78px 362.205px"
    },
    id: "eljo8ds7amgcf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.08,372.76H121.75a1.8,1.8,0,0,0,0,3.59h25.33a1.8,1.8,0,1,0,0-3.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "134.549px 374.555px"
    },
    id: "el242yi7u35zu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.06,
    y: 388.37,
    width: 33.5,
    height: 33.5,
    style: {
      fill: "rgb(191, 191, 191)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "94.81px 405.12px"
    },
    id: "el8rvyaco0lyt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.75,392H225.31a1.8,1.8,0,1,0,0-3.59H121.75a1.8,1.8,0,0,0,0,3.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "173.664px 390.205px"
    },
    id: "eltdy5t62cqe8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.78,400.72h-120a1.8,1.8,0,0,0,0,3.59h120a1.8,1.8,0,0,0,0-3.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "181.78px 402.515px"
    },
    id: "elmblwjm6edxa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.85,413.06H121.75a1.8,1.8,0,0,0,0,3.59h117.1a1.8,1.8,0,1,0,0-3.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "180.434px 414.855px"
    },
    id: "elwwhwce3l9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.78,425.41h-120a1.8,1.8,0,0,0,0,3.59h120a1.8,1.8,0,0,0,0-3.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "181.78px 427.205px"
    },
    id: "el5ahkwnh04dg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.08,437.76H121.75a1.8,1.8,0,0,0,0,3.59h25.33a1.8,1.8,0,1,0,0-3.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "134.549px 439.555px"
    },
    id: "elorm4e8cbc38",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-33",
    className: "animable animator-active",
    style: {
      transformOrigin: "317.301px 268.989px"
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "280.73 99.35 289.19 111.74 281.32 117.74 274.28 107.25",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "281.735px 108.545px"
    },
    id: "elx4q8qsonxm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.52 112.23 285.01 103.41 275.48 110.59 280.2 119.36 291.52 112.23",
    style: {
      fill: "#3B9BE8",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "283.5px 111.385px"
    },
    id: "elg8tovwjajic",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.94,157.61l-.22,29.27s-3.55-1.76-8.63-4.4c-9.15-4.77-23.25-12.38-30.37-17.63a19,19,0,0,1-4-3.62c-4.61-6.59-27.33-45.47-27.33-45.47L288.56,107l22,32.46,5.4,8,.5.17Z",
    style: {
      fill: "rgb(153, 153, 153)",
      transformOrigin: "311.665px 146.94px"
    },
    id: "el587g96vjnkl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(&quot",
      transformOrigin: "324.845px 160.965px"
    },
    id: "el25efeq8nchr",
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "el8qxydkylpbu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342,169.22l-3.94,13.26c-9.15-4.77-23.25-12.38-30.37-17.63C321.67,167.51,342,169.22,342,169.22Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "324.845px 173.665px"
    },
    className: "animable",
    id: "ely1ubs2anja"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el244din3c1pj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.46,147.58c-4.32,1.15-5.66,4-5.66,4-2-5.31-1.39-9.38-.24-12.13l5.4,8Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "312.977px 145.515px"
    },
    className: "animable",
    id: "elamspasvjffd"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M346.94,157.61l-.22,29.27s-3.55-1.76-8.63-4.4c-9.15-4.77-23.25-12.38-30.37-17.63a19,19,0,0,1-4-3.62c-4.61-6.59-27.33-45.47-27.33-45.47L288.56,107l22,32.46,5.4,8,.5.17Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "311.665px 146.94px"
    },
    id: "elyhigi9sm8tk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.2,101.71a5.85,5.85,0,0,0,.6-2.28,9.83,9.83,0,0,0-.3-3.16,11.08,11.08,0,0,0-1.25-3A17.42,17.42,0,0,1,279,90.62c-.24-.62-.45-1.24-.63-1.83a32.85,32.85,0,0,1-.9-3.72s-2-.67-2.22,1.27a5.83,5.83,0,0,0,.07,1.6c.16.9.45,1.83.62,2.58a2.42,2.42,0,0,1,.08,1.33,2.09,2.09,0,0,1-.28.46.12.12,0,0,0,0,0l-.12.16a2.4,2.4,0,0,1-.92.68,1.4,1.4,0,0,1-.49.11.27.27,0,0,1-.13,0,1.61,1.61,0,0,1-.37,0,6.8,6.8,0,0,1-1.87-.7h0A19.8,19.8,0,0,1,269.33,91h0c-.3-.23-.59-.45-.87-.68a26.1,26.1,0,0,1-2-1.8c-.45-.45-.95-.94-1.47-1.4s-1-.87-1.48-1.24c-1.42-1.07-2.72-1.62-3.17-.52s.09,1.43,1.23,2.49c.4.37.88.82,1.43,1.38a27.11,27.11,0,0,1,2.61,3.2h0l.31.44-.42.58c.07.11-.18,0-.66-.2h0a31.59,31.59,0,0,1-3.61-2.12c-.52-.34-1.07-.73-1.61-1.12s-1-.73-1.44-1.11c-2.31-1.89-2.85.28-2.47,1.24A7.75,7.75,0,0,0,258,92.23l1.61,1.19.75.59c1,.8,2,1.61,2.67,2.17l.28.22-.24.91-.43-.11h0A21.48,21.48,0,0,1,259,95.93c-.79-.36-1.4-.7-1.88-1-.9-.47-1.39-.63-2-.09s0,1.55,1,2.41a10.22,10.22,0,0,0,2.66,1.61h0a5.31,5.31,0,0,0,.53.17,10.9,10.9,0,0,1,2.56,1.22l.49.29.17.74-.8-.08h0a21.46,21.46,0,0,1-2.5-.46h0a19.33,19.33,0,0,0-2-.44,1.06,1.06,0,0,0-1.13.4c-.39.58.22,1.22,1.15,1.75a9.28,9.28,0,0,0,1.78.74,5.59,5.59,0,0,0,1.4.27,11.39,11.39,0,0,1,2.6.65l1,.37c1.24.45,2.38.92,2.77,1.08l.15.06c.82.54,1.54,1,2.18,1.33a11.59,11.59,0,0,0,4.92,1.6,3.35,3.35,0,0,0,2.18-.85",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "268.349px 96.6544px"
    },
    id: "elf92lpmpodcs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.06,93.32s-2.69,3.3-.47,6.46",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "273.386px 96.55px"
    },
    id: "elbqqx3mojkn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.9,168.19s3.41,6.32,12.25,11.87",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "330.025px 174.125px"
    },
    id: "el65e78fulsmg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,147.41s-7,.52-4.8,7.34",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "313.386px 151.08px"
    },
    id: "els8wvsf31ngm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.43,423.87s-19.23,16.41-29.26,19.07S398,453.16,398,453.16h23.4l10-2.16v2.22h6.21s5.52-2.83,4.15-17C441.71,435.35,434.43,423.87,434.43,423.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "419.801px 438.545px"
    },
    id: "eln7crbdvhuas",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.43,428.87s-16.23,11.41-26.26,14.07S193,453.16,193,453.16h23.4l10-2.16v2.22h6.21s5.52-2.83,4.15-17q-.12-1.31-.33-2.73C234.08,417,226.43,428.87,226.43,428.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "214.801px 438.978px"
    },
    id: "el27pu7ailrv3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.55,436.8s-60.28-48.73-63.72-55.06-10.27-64.29-10.27-64.29h0c-.88.62-57.38,40.73-60,44.62-.18.27-.55.85-1.09,1.71-7.48,11.85-46.93,76-46.93,76a22.49,22.49,0,0,1-17.41-7.42l40.64-87.59,59.56-58.24h0l.89-.88L327.9,263,379,256.75s4.4,16.21,6.75,28.92a18.13,18.13,0,0,1,.15,2.42c.26,14.26-3.82,78.25-1.7,83.62,2.28,5.81,50.91,51.44,50.91,51.44C435.63,433.48,420.55,436.8,420.55,436.8Z",
    style: {
      fill: "rgb(117, 117, 117)",
      transformOrigin: "328.127px 348.271px"
    },
    id: "eltpmytcuw4n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(&quot",
      transformOrigin: "335.643px 310.265px"
    },
    id: "ellnk4f5vbw3",
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "el7eup6nbruo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.56,317.45h0c-.88.62-57.38,40.73-60,44.62-.18.27-.55.85-1.09,1.71-2.18-14.39,38.44-44.86,38.44-44.86l-8.24-4.26,16.22-2.39c-5.62-2.6-3.76-9.69-3.76-9.69Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "315.973px 333.18px"
    },
    className: "animable",
    id: "elkpkoglc2848"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el2m58kc90rii"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.91,294.27l2.68,4c-15.88-3.51-25.81-8.36-31.26-11.72l.89-.88L327.9,263,379,256.75s4.4,16.21,6.75,28.92a18.13,18.13,0,0,1,.15,2.42C372.37,293.35,349.91,294.27,349.91,294.27Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "353.615px 277.51px"
    },
    className: "animable",
    id: "el9diz3dajsqd"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M420.55,436.8s-60.28-48.73-63.72-55.06-10.27-64.29-10.27-64.29h0c-.88.62-57.38,40.73-60,44.62-.18.27-.55.85-1.09,1.71-7.48,11.85-46.93,76-46.93,76a22.49,22.49,0,0,1-17.41-7.42l40.64-87.59,59.56-58.24h0l.89-.88L327.9,263,379,256.75s4.4,16.21,6.75,28.92a18.13,18.13,0,0,1,.15,2.42c.26,14.26-3.82,78.25-1.7,83.62,2.28,5.81,50.91,51.44,50.91,51.44C435.63,433.48,420.55,436.8,420.55,436.8Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "328.127px 348.271px"
    },
    id: "elrcro1jgyhf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.4,212.21c-2.86,16.09-14.34,35.72-14.34,35.72l2.7,8.41L387,278.83l-39.41,11.74-7.17-13.47-6.61,12.49-13.42-5.38,1.1-5.66,2.54-13.1c-.06-.74-.11-1.52-.17-2.32-1.65-24.34-1.48-74.29,21.25-106,0,0,33.74,4.7,46.09,42.43C392.32,203.07,392.23,207.49,391.4,212.21Z",
    style: {
      fill: "rgb(153, 153, 153)",
      transformOrigin: "356.211px 223.85px"
    },
    id: "elza17h6umqm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(&quot",
      transformOrigin: "356.43px 245.38px"
    },
    id: "els6tjs2xtlcm",
    className: "animable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elzu81bd3f7y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.06,247.93l2.7,8.41c-6.72,6.21-14.82,13.72-15.59,14.66-1,1.21-28.62,5.45-42.71,7.55l2.54-13.1c-.06-.74-.11-1.52-.17-2.32L381,216l10.4-3.79C388.54,228.3,377.06,247.93,377.06,247.93Z",
    style: {
      fillOpacity: 0.7,
      opacity: 0.3,
      transformOrigin: "356.43px 245.38px"
    },
    className: "animable",
    id: "elffzq21n3mtg"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M391.4,212.21c-2.86,16.09-14.34,35.72-14.34,35.72l2.7,8.41L387,278.83l-39.41,11.74-7.17-13.47-6.61,12.49-13.42-5.38,1.1-5.66,2.54-13.1c-.06-.74-.11-1.52-.17-2.32-1.65-24.34-1.48-74.29,21.25-106,0,0,33.74,4.7,46.09,42.43C392.32,203.07,392.23,207.49,391.4,212.21Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "356.211px 223.85px"
    },
    id: "el8udbrzb8q6y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.69,221.5s55.32-44.82,34.9-51.86C354.2,163.29,330.7,177.56,337.69,221.5Z",
    style: {
      fill: "#3B9BE8",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "356.771px 194.852px"
    },
    id: "eld0llvzohe5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.51,185.65l-7.6,3.29a112.4,112.4,0,0,0-7.42,30.88l-5.86,7.41L335,219.82s2.86-22.43,12.57-31.59l2.35-8.91,9.18-4.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "347.05px 200.925px"
    },
    id: "elahqmzgtj147",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.27,218.66s43.65-30.54,33.58-51c0,0,11.95-.31,6.9,29l-14.58,4.25,4.07,8.15s-16.42,3.32-31.61,18.15l-5.93-34.89,4.29-3.17-2.52-5.36S347.56,167,362,168.41c0,0-17.2,7.15-21.66,20.76S338.27,218.66,338.27,218.66Z",
    style: {
      fill: "rgb(191, 191, 191)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "355.347px 197.435px"
    },
    id: "elj8urotjmim",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.28,166.63s-13.41,4.05-19.4,17.27l7.21-2.67.73,2.23,3.61,1.49v7.39s20.65-9.35,20.69-16.93C376.13,173.26,371,163.16,363.28,166.63Z",
    style: {
      fill: "#3B9BE8",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "360px 179.125px"
    },
    id: "elz15hb3pnons",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.42,155.27c-5.24,8.41-1.77,18.7-1.77,18.7S359,185.63,354.1,182.39a70.75,70.75,0,0,0-.23-10,66.77,66.77,0,0,0-1.28-8.48s1.66-1,4.11-2.33C364.51,157.19,380.42,148.87,376.42,155.27Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "364.822px 167.947px"
    },
    id: "elixkd99hq1jb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.22,295a8.81,8.81,0,0,0,1.37-1.36,5.78,5.78,0,0,0,.77-1.2,11.94,11.94,0,0,1,1.59-2.16l.74-.82c.89-1,1.75-1.85,2.05-2.15l.11-.12c.81-.56,1.48-1.05,2-1.51a11.58,11.58,0,0,0,3.36-3.95c1.08-2-2-7.21-3.67-9.2a5.9,5.9,0,0,0-1.89-1.41,9.52,9.52,0,0,0-3-.93,11.44,11.44,0,0,0-3.25,0,17.45,17.45,0,0,1-2.92.16c-.66,0-1.32-.06-1.93-.12a34.48,34.48,0,0,1-3.79-.57,1.59,1.59,0,0,0,.34,2.53,5.8,5.8,0,0,0,1.5.54c.9.2,1.87.29,2.62.41a2.38,2.38,0,0,1,1.27.43,2.52,2.52,0,0,1,.32.43l0,0,.1.17a2.53,2.53,0,0,1,.28,1.11,1.57,1.57,0,0,1-.08.49.33.33,0,0,1,0,.13,2.68,2.68,0,0,1-.18.33,6.7,6.7,0,0,1-1.36,1.46h0a19.37,19.37,0,0,1-2.43,1.7h0l-1,.54a26.17,26.17,0,0,1-2.43,1.19c-.59.25-1.23.53-1.85.83a17.14,17.14,0,0,0-1.71.9c-1.54.91-2.53,1.9-1.69,2.73s1.36.47,2.78-.19c.49-.23,1.08-.5,1.81-.8a28.56,28.56,0,0,1,3.95-1.21h0l.52-.12.38.6c.13,0,0,.19-.43.54h0A33.82,33.82,0,0,1,266.2,287c-.52.35-1.09.72-1.66,1.06s-1,.63-1.57.91c-2.62,1.43-.82,2.75.21,2.76a7.71,7.71,0,0,0,2.83-1.31l1.72-1.05.83-.46c1.1-.59,2.24-1.22,3-1.65l.3-.17.76.56-.26.36h0a21.43,21.43,0,0,1-2.55,2.87c-.64.6-1.18,1-1.59,1.38-.77.67-1.11,1.06-.83,1.79s1.43.61,2.6,0a10.22,10.22,0,0,0,2.49-1.85h0a4.32,4.32,0,0,0,.36-.43,10.42,10.42,0,0,1,2.09-1.9l.46-.34.75.12c-.12.25-.25.49-.38.71h0a22,22,0,0,1-1.37,2.14h0a19.08,19.08,0,0,0-1.18,1.7,1,1,0,0,0-.05,1.19C273.55,296,274.39,295.63,275.22,295Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "273.794px 282.681px"
    },
    id: "el2knbpmqz6i8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "281.16 272.4 295.37 267.57 299.04 276.75 287.05 280.73",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "290.1px 274.15px"
    },
    id: "eljzwdx2nzr4i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.46 265.45 286.22 269.36 290.59 280.47 300.3 278.27 296.46 265.45",
    style: {
      fill: "#3B9BE8",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "293.26px 272.96px"
    },
    id: "elblzuransli",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.9,200.93s-6.75-2.73-15.38,2.12c-5.28,3-31.61,44.09-30.64,42.21l-54,21.09,5.53,15.47s56.73-14.37,61.32-17.86,28.67-29,34.09-50.39",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "340.35px 240.992px"
    },
    id: "elas9pno6iv5k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.88,305.37s16.29,9,24.89,17.15",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "344.325px 313.945px"
    },
    id: "el2zr9ir2mjdf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.11,283c-.13.22-.66,9,4.62,12.67",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "379.381px 289.335px"
    },
    id: "elyifk8efzlig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.73,280.73s2.9,1.7,1,27.54S380,370.52,380,370.52a14.9,14.9,0,0,0,3.4,6.06c2.56,2.64,43.7,42.79,43.7,42.79",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "403.55px 350.05px"
    },
    id: "elo6kztcs2ll",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.33,314s-13.33,2.5-24,.92",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "332.33px 314.722px"
    },
    id: "elyhm61exh5y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.39,315.39s-52.55,43.52-63.1,47.21",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "308.84px 338.995px"
    },
    id: "eloyov10vk6pp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.16,
    y1: 360.65,
    x2: 245.9,
    y2: 420.63,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "263.53px 390.64px"
    },
    id: "elv653l3p5fam",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,283.9s-2.23,12.77-3.62,14.88,1.81,9.49,1.81,9.49",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "342.015px 296.085px"
    },
    id: "elfcm1yxln8ho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.39,283.9s-1.65,7.76-2.18,9.61,2.18,2.58,2.18,2.58",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "339.266px 289.995px"
    },
    id: "eljp4t7hpqhbp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,230.21s-1.79,11.08-1.26,16.35",
    style: {
      fill: "rgb(191, 191, 191)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "334.321px 238.385px"
    },
    id: "elq37vco154xt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.73,225.73s-9.27,6.85-17.56,6.59",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "372.95px 229.029px"
    },
    id: "el21znst5015o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.88,245.26s3.76,2.88,6,1.3",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "346.88px 246.147px"
    },
    id: "elvt05cnpfiq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.06,247.93s-5.09,2.85-6.15,5.75",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "373.985px 250.805px"
    },
    id: "elmvx6es4wa8j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.24,163.42s-6.38,6.73-14.37,8.92a66.77,66.77,0,0,0-1.28-8.48s1.66-1,4.11-2.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "360.415px 166.935px"
    },
    id: "elmu97w4jl3md",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.3,164.92c-6.45,3.58-13.76,4.84-20.49,1.71-2.39-1.1-3.55-15.45,0-28.12,5.71-20.47,22.26-21.15,35.59-9,7.05,6.44,2.72,19.24-6.11,28.39",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "368.239px 144.959px"
    },
    id: "el0rshfe891wx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.1,139.78a8,8,0,0,1,8.14,5.18",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "364.17px 142.357px"
    },
    id: "elubnyt1piuhp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.1,137.2s-.86-2.48-3-2.53",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "352.6px 135.935px"
    },
    id: "el54t94z96v1c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.83,151.58s-2.55-2.65-1.75-4.15,1.61-.61,3.51-1.94a5,5,0,0,0,2.12-3.46",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "351.817px 146.805px"
    },
    id: "el5o6g84utwhp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.71,147.28c-.26.66-.77,1.08-1.14.94s-.47-.8-.21-1.47.77-1.08,1.14-.93S363,146.62,362.71,147.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "362.042px 147.018px"
    },
    id: "elexe401zyvba",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.27,142.61c-.26.67-.77,1.09-1.14.94s-.47-.8-.21-1.46.77-1.08,1.14-.94S353.53,142,353.27,142.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "352.595px 142.352px"
    },
    id: "el3g8fv92v69w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.91,154.74s5.26,2.42,9.18,2.47c0,0-2,4.24-5.42,3.86S351,156,351,156",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "354.5px 157.917px"
    },
    id: "eljuq6jbmz4l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.27,133s-5.64-4.53-18-6.61c0,0,.06-7.56,2.85-10.29s5.08,2.9,5.08,2.9,7-1.94,19.43,6.59,6.47,28.27-9.24,36.66l-.09-3.34s.16-6.92-2.42-8.21c0,0,1.93-5-.16-8.69S374.27,133,374.27,133Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "373.291px 138.801px"
    },
    id: "el83fjxg0wkaf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.85,153.13s4.51-5.47,8.21-3.54-4.51,13.67-8.21,11.51",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "376.423px 155.271px"
    },
    id: "eloxy8d4xlf0o",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.94,157.61l-.22,29.27s-3.55-1.76-8.63-4.4c-9.15-4.77-23.25-12.38-30.37-17.63a19,19,0,0,1-4-3.62c-4.61-6.59-27.33-45.47-27.33-45.47L288.56,107l22,32.46,5.4,8,.5.17Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.55,436.8s-60.28-48.73-63.72-55.06-10.27-64.29-10.27-64.29h0c-.88.62-57.38,40.73-60,44.62-.18.27-.55.85-1.09,1.71-7.48,11.85-46.93,76-46.93,76a22.49,22.49,0,0,1-17.41-7.42l40.64-87.59,59.56-58.24h0l.89-.88L327.9,263,379,256.75s4.4,16.21,6.75,28.92a18.13,18.13,0,0,1,.15,2.42c.26,14.26-3.82,78.25-1.7,83.62,2.28,5.81,50.91,51.44,50.91,51.44C435.63,433.48,420.55,436.8,420.55,436.8Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.4,212.21c-2.86,16.09-14.34,35.72-14.34,35.72l2.7,8.41L387,278.83l-39.41,11.74-7.17-13.47-6.61,12.49-13.42-5.38,1.1-5.66,2.54-13.1c-.06-.74-.11-1.52-.17-2.32-1.65-24.34-1.48-74.29,21.25-106,0,0,33.74,4.7,46.09,42.43C392.32,203.07,392.23,207.49,391.4,212.21Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.f6d10fb86cfd134d9f6dbcb3917ed1ea.svg";
export { ForwardRef as ReactComponent };